"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useActive = _interopRequireDefault(require("../hooks/useActive"));

var ActiveProvider = function ActiveProvider(props) {
  return props.children((0, _useActive.default)(props));
};

ActiveProvider.displayName = 'ActiveProvider';
var _default = ActiveProvider;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/providers/ActiveProvider.js
// module id = 660
// module chunks = 5 6